module.exports = __webpack_public_path__ + "img/google-play-store.6fec8523.svg";